import { Component } from '@angular/core';
import { IHeaderParams } from 'ag-grid/main';
import { IHeaderAngularComp } from 'ag-grid-angular/main';

@Component({
  templateUrl: './assign-lane-custom-cell-header.component.html',
  styleUrls: ['./assign-lane-custom-header.component.css']
})
export class AssignLaneHeaderComponent implements IHeaderAngularComp {

  public params: any;
  public templateId: number = 1;
  // Only for Edit icon this is displayed for rest all columns  we are providing styles to display it different from usual


  public agInit(params: IHeaderParams): void {
    this.params = params;


  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/lookup/assign-lane-popup/assign-lane-custom-cell-header/assign-lane-custom-header.component.ts